module.exports = __webpack_public_path__ + "img/timestudy-9.cc1c23f6.png";